import React, { useEffect, useState } from 'react';
import { HomePageDiv } from './styles';
import BannerCarousel from 'common/BannerCarousel/BannerCarousel';
import Destinations from 'common/Destinations/Destinations';
import Tourism from 'common/Tourism/Tourism';
import Schedule from 'common/Schedule/Schedule';
import News from 'common/News/News';
import SocialMedia from 'common/SocialMedia/SocialMedia';
import IHomeData from 'interfaces/IHomeData';
import PublicService from 'services/PublicService';
import VisualIdentityService from 'services/VisualIdentityService';
import HomeFooter from 'common/HomeFooter';
import { useLoading } from 'hooks/useLoading';
import QuizModal from 'features/QuizModal';
import CityMap from 'common/CityMap';
import { env, getCdnUrl } from 'utils/env';

const HomePage = (): JSX.Element => {
  const [data, setHomeData] = useState<IHomeData | undefined>();
  const { openLoading, closeLoading } = useLoading();
  const [mapImage, setMapImage] = useState<string>(
    `${env('REACT_APP_STATIC_URL')}/images/Mapa%20Turistico/novo-mapa-tur%C3%ADstico-porto%20seguro.svg`
  );

  const getData = async () => {
    try {
      openLoading();
      const service = new PublicService();
      const visualIdentityService = new VisualIdentityService();
      const [homeDataResult, eventsResult, touristMapResult] = await Promise.allSettled([
        service.getHomeData(),
        service.getAllEvents(),
        visualIdentityService.getTouristMap(),
      ]);

      const homeDataObj = homeDataResult.status === 'fulfilled' ? homeDataResult.value : undefined;
      const eventsObj = eventsResult.status === 'fulfilled' ? eventsResult.value : undefined;

      if (homeDataObj) {
        setHomeData({ ...homeDataObj, events: eventsObj || [] });
      }

      if (touristMapResult.status === 'fulfilled' && touristMapResult.value) {
        const fetchedMap = touristMapResult.value;
        const formattedUrl = fetchedMap.startsWith('data:') ? fetchedMap : getCdnUrl(fetchedMap);
        setMapImage(formattedUrl);
      }

      closeLoading();
    } catch (error) {
      closeLoading();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <HomePageDiv>
      <BannerCarousel banners={data?.banners} />
      <Destinations destinations={data?.destinations} />
      <Tourism experiences={data?.experiences} />
      <Schedule events={data?.events} />
      <News news={data?.news} />
      <SocialMedia />
      <CityMap image={mapImage} />
    </HomePageDiv>
  );
};

export default HomePage;
